import LogsCitc from './LogsCitc';

export default LogsCitc;
